module.exports = __webpack_public_path__ + "static/media/mountains-big-taggis.96b3c396.jpg";